import { makeVar } from '@apollo/client';
import { useReactiveVar } from '@apollo/client/react';

export interface GuestAddToCartSignInDialogState {
  isOpen: boolean;
}

export const defaultGuestAddToCartSignInDialogState: GuestAddToCartSignInDialogState =
  {
    isOpen: false,
  };

export const guestAddToCartSignInDialogVar =
  makeVar<GuestAddToCartSignInDialogState>(
    defaultGuestAddToCartSignInDialogState
  );

export const openGuestAddToCartSignInDialog = () => {
  guestAddToCartSignInDialogVar({
    isOpen: true,
  });
};

export const closeGuestAddToCartSignInDialog = () => {
  guestAddToCartSignInDialogVar(defaultGuestAddToCartSignInDialogState);
};

export const useGuestAddToCartSignInDialogState = () => {
  return useReactiveVar(guestAddToCartSignInDialogVar);
};
